import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Check, Loader2, X } from "lucide-react";
import api from "@/lib/api";

export default function BookingSuccess() {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get("session_id");
    const [status, setStatus] = useState("checking");
    const [attempts, setAttempts] = useState(0);

    useEffect(() => {
        if (!sessionId) { setStatus("error"); return; }
        const poll = async () => {
            try {
                const res = await api.get(`/checkout/status/${sessionId}`);
                if (res.data.payment_status === "paid") {
                    setStatus("success");
                } else if (res.data.status === "expired") {
                    setStatus("expired");
                } else {
                    setAttempts((a) => a + 1);
                }
            } catch {
                setAttempts((a) => a + 1);
            }
        };
        if (status === "checking" && attempts < 10) {
            const timer = setTimeout(poll, attempts === 0 ? 500 : 2000);
            return () => clearTimeout(timer);
        } else if (attempts >= 10) {
            setStatus("timeout");
        }
    }, [sessionId, attempts, status]);

    return (
        <div className="min-h-screen bg-white flex items-center justify-center px-6" data-testid="booking-success-page">
            <div className="max-w-md w-full text-center">
                {status === "checking" && (
                    <>
                        <Loader2 size={48} className="mx-auto animate-spin text-neutral-400 mb-6" />
                        <h1 className="text-2xl font-medium tracking-tight mb-2">Kontrollerar betalning...</h1>
                        <p className="text-sm text-neutral-500">Vänta medan vi bekräftar din betalning.</p>
                    </>
                )}
                {status === "success" && (
                    <>
                        <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mx-auto mb-6">
                            <Check size={32} className="text-white" />
                        </div>
                        <h1 className="text-2xl font-medium tracking-tight mb-2">Bokning mottagen!</h1>
                        <p className="text-sm text-neutral-500 mb-8 leading-relaxed">
                            Tack för din bokning. Vi bekräftar inom 24 timmar via e-post.
                        </p>
                        <Link to="/" className="inline-flex items-center bg-black text-white px-8 py-3 text-xs uppercase tracking-[0.2em] font-medium hover:bg-neutral-800 transition-colors" data-testid="back-to-home">
                            Tillbaka till startsidan
                        </Link>
                    </>
                )}
                {(status === "error" || status === "expired" || status === "timeout") && (
                    <>
                        <div className="w-16 h-16 bg-neutral-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <X size={32} className="text-neutral-400" />
                        </div>
                        <h1 className="text-2xl font-medium tracking-tight mb-2">Något gick fel</h1>
                        <p className="text-sm text-neutral-500 mb-8">
                            {status === "expired" ? "Betalningssessionen har löpt ut." : "Vi kunde inte bekräfta din betalning. Kontakta oss om du har frågor."}
                        </p>
                        <Link to="/" className="inline-flex items-center bg-black text-white px-8 py-3 text-xs uppercase tracking-[0.2em] font-medium" data-testid="back-to-home-error">
                            Tillbaka
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
}
